import { render } from "./NetworkForm.vue?vue&type=template&id=12b04886&ts=true"
import script from "./NetworkForm.vue?vue&type=script&lang=ts"
export * from "./NetworkForm.vue?vue&type=script&lang=ts"

import "./NetworkForm.vue?vue&type=style&index=0&id=12b04886&lang=css"

import exportComponent from "/root/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__